import { ReservationCancelConfirmedModel } from './../../../models/Booking/ReservationCancelConfirmedModel';
import { LoadingService } from './../../../services/loading.service';
import { VehicleReservationState } from './../../../models/enums/BookingEnums';
import { CancelConfirmationModalComponent } from './../cancel-confirmation-modal/cancel-confirmation-modal.component';
import { SearchService } from './../../../services/search.service';
import { Component, OnInit, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";
import { FormBuilder, FormGroup, Validators, FormControl } from '@angular/forms';
import { faTimesCircle } from '@fortawesome/free-regular-svg-icons';
import { AuthService } from './../../../services/auth.service';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { BookingService } from 'src/app/services/booking.service';
import { MatDialog, MatDialogConfig } from "@angular/material/dialog";
import { DomSanitizer } from "@angular/platform-browser";
import { ActivatedRoute } from '@angular/router';
import { MatIconRegistry } from "@angular/material/icon";

@Component({
  selector: 'cancelation-modal',
  templateUrl: './cancelation-modal.component.html',
  styleUrls: ['./cancelation-modal.component.css']
})
export class CancelationModalComponent implements OnInit {

  faTimesCircle = faTimesCircle;
  reasons;
  caseId;
  results;
  reservationCancelConfirmedModel: any;
  isFreeCancellation;
  cancellationObj: Object;
  showValidation: boolean = false;
  currency;


  data;
  constructor(
    private loadingService: LoadingService,
    private bookinService: BookingService,
    private searchService: SearchService,
    private bookingService: BookingService,
    private dialogRef: MatDialogRef<CancelationModalComponent>,
    @Inject(MAT_DIALOG_DATA) data,
    private formBuilder: FormBuilder,
    private router: Router,
    public translateService: TranslateService,
    private domSanitizer: DomSanitizer,
    private route: ActivatedRoute,
    private dialog: MatDialog,) {


  }

  ngOnInit() {
    this.currency = this.searchService.getCurrency();
    this.caseId = this.bookinService.CaseID;
    this.bookingService.getOnlineCustomerCancellationReason().subscribe(res => {
      this.reasons = res;
    })
    this.bookinService.getCancelationPolicy(this.caseId).subscribe(res =>{

      if(res!=null){
        this.cancellationObj=res;
        if(res["isFree"]){
          this.isFreeCancellation=true;

        }
        else{
          this.isFreeCancellation=false;

        }
      }
    })
  }

  close(): void {
    this.dialogRef.close();
  }

  openCancelConfirmation() {

  }

  cancelForm = new FormGroup({
    reasonId: new FormControl('', Validators.required),
    comments: new FormControl(''),
  });


  checkValid(){
    ;

    if (this.cancelForm.controls["reasonId"].value == ""){
      this.showValidation = true;
    } else{
      if (this.cancelForm.controls["reasonId"].value != ""){
        this.showValidation = false;}
    }

  }


  onSubmit() {
     ;
    this.dialogRef.close();
    setTimeout(() => {
      this.loadingService.updateLoadingState(true);
    });
    this.bookingService.reservationCancelConfirmed(this.caseId, this.cancelForm.controls["reasonId"].value, this.cancelForm.controls["comments"].value).subscribe(res => {

      this.reservationCancelConfirmedModel = res;
      var objCase = JSON.stringify(this.reservationCancelConfirmedModel.result);
      if (this.reservationCancelConfirmedModel != null) {
       // if (objCase.CaseStateID == VehicleReservationState.Cancelled) {

          const dialogConfig = new MatDialogConfig();
          dialogConfig.data = {
            refundableAmountValue: this.reservationCancelConfirmedModel.refundableAmount,
          }
          ;
          this.data = this.reservationCancelConfirmedModel.refundableAmount;
          this.dialog.open(CancelConfirmationModalComponent,  dialogConfig);
          //this.router.navigate(["/view-booking;CaseID=" + this.caseId]);
       // }
      }
      this.loadingService.updateLoadingState(false);

    })

  }


}
